import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../../PanelPage";
import {LoginWithEmailCode} from "../../../../common/auth/LoginWithEmailCodeForm.jsx";
import {Messages} from "../../../../Messages";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {authFormService} from "../../../../services/AuthFormService";
import {userService} from "../../../../../client/connection/services/UserService";
import {wrapInSpinner} from "../../../../../core/ui/LoadingSpinner.jsx";
import {apiConfirmUserEmailChange} from "../../../../../client/state/UserProfileStore";
import {DefaultCodeConfirmationForm} from "../../../../common/auth/DefaultCodeConfirmationForm.jsx";
import {INLINE_USER_DASHBOARD_URLS} from "../../../PanelConstants";
import {Toast} from "../../../../ui/Toast.jsx";


class UserDashboardChangeEmailCodeConfirmationComponent extends LoginWithEmailCode {
    canDisplayResendCodeOption = false;

    getEmailConfirmationFormClass() {
        return DefaultCodeConfirmationForm;
    }

    getBeforeInput() {
        return [
            <div className={this.styleSheet.title}>{Messages.confirmEmailChangeModalTitle}</div>,
            <div className={this.styleSheet.text}><MessageElement message={Messages.confirmEmailChangeLine1} args={[authFormService.changeToEmailAddress]}/></div>,
            <div className={this.styleSheet.text}><MessageElement message={Messages.confirmEmailChangeLine2} args={[authFormService.changeToEmailAddress, userService.getUserEmail()]}/></div>,
        ];
    }

    @wrapInSpinner
    async handleSubmit(code) {
        await apiConfirmUserEmailChange({code});
        Toast.showSuccess(Messages.emailSuccessfullyChanged);
        Router.changeURL(INLINE_USER_DASHBOARD_URLS.home);
    }
}

export class UserDashboardChangeEmailCodeConfirmPanel extends BasePanelPage {
    render() {
        return <UserDashboardChangeEmailCodeConfirmationComponent />;
    }
}
